/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Max_Wpm_LabelInputs */



/**
* | output |
* | --- |
* | "Max Words Per Minute (WPM)" |
*
* @param {Edit_Event_Group_Max_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_max_wpm_label = /** @type {((inputs?: Edit_Event_Group_Max_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Max_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre maximal de mots par minute (WPM)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Wörter pro Minute (WPM)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di parole al minuto (WPM)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальная скорость печати (слов в минуту)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de palabras por minuto (WPM)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟最大字数 (WPM)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1分あたりの最大単語数（WPM）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम शब्द प्रति मिनट (WPM)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Máximo de palavras por minuto (PPM)")
	return /** @type {LocalizedString} */ ("Max Words Per Minute (WPM)")
});